
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.857 3.5A4.645 4.645 0 0141.5 8.143v28.714a4.645 4.645 0 01-4.643 4.643h-7.902V27.182h4.943l.94-6.132h-5.883v-3.98c0-1.677.822-3.312 3.458-3.312h2.675v-5.22s-2.428-.415-4.75-.415c-4.845 0-8.012 2.937-8.012 8.253v4.674H16.94v6.132h5.386V41.5H8.143A4.645 4.645 0 013.5 36.857V8.143A4.645 4.645 0 018.143 3.5h28.714z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    